import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import useTokenStore from "../Store/Store";
import Populal from "./Recomend/Popular";
import BossRecomend from "./Recomend/BossRecomend";
import NewMenu from "./Recomend/NewMenu";
import Event from "./Recomend/Event";
import { useCookies } from 'react-cookie';

const Styled = {
  Wrap: styled.div`
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    margin-top:${(props) => (props.isFixed ? "200px" : "0px")};;
  `,
  MenuHeaderBox: styled.div`
    width: 90%;
    height: 48px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
  `,
    MenuHeaderTextBox:styled.div`
      width:100%;
      height:24px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      flex-direction: row;
      margin-top:14px;
    `,
  MenuHeader: styled.p`
    font-size: 20px;
    font-weight: 700;
    color: #000000;
    margin: 0px;
    padding:0px;
    font-family: 'PreFont';
  `,
  MenuColumnWrap: styled.div`
    margin-top: 10px;
    width: 90%;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
  `,
  MenuBox: styled.div`
    width: 48.4%;
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    box-shadow: 0px 0px 20px #eeeeee;
    border-radius: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    paddgin-bottom:20px;
  `,
  MenuImg: styled.img`
    width: 100%;
    height: 120px;
    border-radius: 10px 10px 0px 0px;
    object-fit: cover;
    object-position: center;
  `,
  MenuInfoBox: styled.div`
    width: 84.5%;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    margin-top:12px;
    padding-bottom: 10px;
  `,
  MenuInfoTextBox:styled.div`
    width:100%;
    height:auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction:row;
  `,
  MenuName: styled.p`
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    margin: 0px;
    font-family: 'PreFont';
    padding:0px;
  `,
  MenuPrice: styled.p`
    font-size: 14px;
    font-weight: 600;
    font-family: 'PreFont';
    color: #000000;
    margin:0px;
    padding:0px;
  `,

  MenuRecommendWrap:styled.div`
      width:auto;
      height:20px;
      display:flex;
      justify-content:space-between;
      align-items:flex-start;
      flex-direction:row;
  `,
};

const Menu = (props) => {
  const navigate = useNavigate();
  const { setMenu } = useTokenStore();
  const { CateGori, RestaurantInfo } = props;
  const [MenuData, setMenuData] = useState([]);
  const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);

  const [isFixed, setIsFixed] = useState(false); // 스크롤 상태 관리

  useEffect(() => {
    const handleScroll = () => {
        setIsFixed(window.scrollY >= 96); // 스크롤이 90px 이상이면 true
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll); // 클린업
  }, []);

  useEffect(() => {
    // 원하는 name 값 필터링
    const targetName = CateGori.KR;
    const result = RestaurantInfo
      .filter((item) => item.names.KR === targetName)
      .flatMap((item) => item.menus || []); // 안전한 접근

    setMenuData(result); // 상태 업데이트
  }, [CateGori, RestaurantInfo]);

  function addCommasEveryThirdDigit(number) {
    return number.toLocaleString("en-US");
  }

  return (
    <Styled.Wrap id={CateGori[Langcookies["PageLang"]]}>
      <Styled.MenuHeaderBox>
        <Styled.MenuHeaderTextBox>
          <Styled.MenuHeader>{CateGori[Langcookies["PageLang"]]}</Styled.MenuHeader>
        </Styled.MenuHeaderTextBox>
      </Styled.MenuHeaderBox>
      <Styled.MenuColumnWrap>
        {MenuData.length > 0 ? (
          MenuData.map((v) => (
            <Styled.MenuBox
              key={v.id}
              onClick={() => {
                setMenu(v);
                navigate("/menu");
              }}
            >
              <Styled.MenuImg
                src={`https://zzikgomainapi.co.kr${v.image}`}
              />
              <Styled.MenuInfoBox>
                <Styled.MenuInfoTextBox>
                  <Styled.MenuName>{v.names[Langcookies["PageLang"]]}</Styled.MenuName>
                </Styled.MenuInfoTextBox>
                <Styled.MenuInfoTextBox>
                  <Styled.MenuPrice>
                    {addCommasEveryThirdDigit(v.price)}원
                  </Styled.MenuPrice>
                </Styled.MenuInfoTextBox>
                <Styled.MenuRecommendWrap>
                {v.tag.length !== 0 ? (
                    v.tag
                      .flatMap(tagString => tagString.split(',')) // ["신메뉴,인기"] → ["신메뉴", "인기"]
                      .map((tag, idx) => (
                        <Styled.MenuRecommendWrap>
                          {tag === "신메뉴" && <NewMenu />}
                          {tag === "인기" && <Populal />}
                          {tag === "사장님 추천" && <BossRecomend />}
                          {tag === "영수증 이벤트" && <Event />}
                        </Styled.MenuRecommendWrap>
                      ))
                  ) : (
                    <></>
                  )}
                  </Styled.MenuRecommendWrap>

                </Styled.MenuInfoBox>
              </Styled.MenuBox>
            ))
          ) : (
            <p>메뉴가 없습니다.</p>
          )}
      </Styled.MenuColumnWrap>
    </Styled.Wrap>
  );
};

export default Menu;
